import { AnimatedHeader } from '@/components/animated-header';
import { Footer } from '@/components/footer';
import { HeroSection } from '@/components/hero-section';
import { useAnimatedHeader } from '@/hooks/use-animated-header';
import { Image } from 'expo-image';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import Animated, { Extrapolation, interpolate, useAnimatedStyle } from 'react-native-reanimated';

const AnimatedImage = Animated.createAnimatedComponent(Image);

export default function ScenarioHome() {
  const { headerTranslateY, scrollY, scrollHandler, totalHeight } = useAnimatedHeader();
  const { height: windowHeight } = useWindowDimensions();

  const heroBackgroundStyle = useAnimatedStyle(() => {
    const scale = interpolate(scrollY.value, [-windowHeight, 0, windowHeight], [1.5, 1.1, 1], Extrapolation.CLAMP);

    return {
      transform: [
        {
          translateY: interpolate(scrollY.value, [0, windowHeight], [0, windowHeight * 0.4], Extrapolation.CLAMP),
        },
        {
          scale,
        },
      ],
    };
  });

  return (
    <View style={styles.container}>
      <Animated.ScrollView
        style={styles.scrollView}
        onScroll={scrollHandler}
        scrollEventThrottle={16}
        contentContainerStyle={[styles.scrollContent, { paddingTop: totalHeight }]}>
        <Animated.View style={styles.backgroundContainer}>
          <Animated.View style={[StyleSheet.absoluteFill, heroBackgroundStyle]}>
            <AnimatedImage
              source={require('@/assets/images/background-r.webp')}
              style={styles.backgroundImage}
              contentFit='cover'
            />
          </Animated.View>
        </Animated.View>

        {/* HERO SECTION */}
        <HeroSection totalHeight={totalHeight} />

        <Footer />
      </Animated.ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#E3E3E3',
  },
  scrollView: {
    flex: 1,
    width: '100%',
    backgroundColor: 'transparent',
  },
  scrollContent: {
    flexGrow: 1,
  },
  backgroundContainer: {
    height: 400,
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  backgroundImage: {
    flex: 1,
    width: '100%',
  },
});
